import config from '../../config'

if (process.env.NODE_ENV !== 'production') 
  config.api_root_url = 'http://localhost:8680/api/'

export default config



// WEBPACK FOOTER //
// ./client/src/config.js